module.exports = __webpack_public_path__ + "img/glassquality_1.1baa86af.png";